import { http, HttpResponse, delay } from 'msw'
import { fakeEmailTemplates } from '../fake-data/fake-email-templates'

export const emailTemplates = [
  http.get('/api/emailTemplates', async () => {
    await delay(900)

    return HttpResponse.json(fakeEmailTemplates)
  }),

  http.get('/api/emailTemplates/:id', async ({ params }) => {
    await delay(300)

    const { id } = params

    const foundTemplate = id ? fakeEmailTemplates.find((template) => template.id === Number(id)) : undefined

    if (!foundTemplate) {
      return HttpResponse.json(undefined, { status: 404 })
    } else {
      return HttpResponse.json(foundTemplate)
    }
  }),

  http.post('/api/emailTemplates', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.put('/api/emailTemplates/:id', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  }),

  http.delete('/api/emailTemplates/:id', async () => {
    await delay(300)

    return HttpResponse.json(undefined, { status: 204 })
  })
]
